angular.module('bizmetryApp').service('LiveChartViewport', function () {
    var snapshots = new WeakMap();
    // Timestamp identifies a bucket even when its array index changes.
    this.capture = function (chart) {
        if (!chart) return;
        snapshots.set(chart, new Map(chart.data.datasets.map(function (ds) {
            return [ds.label, (ds.data || []).slice()];
        })));
    };
    this.cancel = function (chart) {
        if (chart) snapshots.delete(chart);
    };
    this.slide = function (chart, min, max) {
        var previous = snapshots.get(chart);
        snapshots.delete(chart);
        chart.data.datasets.forEach(function (ds) {
            var old = previous && previous.get(ds.label) || [];
            var byTime = new Map(old.map(function (point) { return [point.x, point]; }));
            ds.data = (ds.data || []).map(function (point) {
                var existing = byTime.get(point.x);
                if (existing) { Object.assign(existing, point); return existing; }
                return point;
            });
        });
        // Advance only when fresh data arrives; keep the axis fixed between refreshes.
        chart.options.animation = false;
        chart.options.scales.x.min = min;
        chart.options.scales.x.max = max;
        chart.update('none');
    };
});
